const upUserImg = (data) => {
    let bool = data.id == data.mmcount;
    if (data.isStartSpeech) {  //正在讲话
        if (data.role == 0 && data.online == 3) {
            return bool ? require("@/assets/group/zzjhdyh1.png") : require("@/assets/group/zzjhdyh.png");
        }

        if (data.role == 3 && data.online == 3) {
            return bool ? require("@/assets/group/zzjh1.png") : require("@/assets/group/zzjh.png");
        }
    } else {
        // 摇闭开始
        if (data.role == 0 && data.online != 3 && !data.audioEnabled) {
            return bool ? require("@/assets/group/shakeCloseLx2.png") : require("@/assets/group/shakeCloseLx.png");
        }
        // 离线
        if (data.role == 3 && data.online != 3 && !data.audioEnabled) {
            return bool ? require("@/assets/group/shakeCloseLx3.png") : require("@/assets/group/shakeCloseLx1.png");
        }
        // 在线
        if (data.role == 0 && data.online == 3 && data.Ingroup && !data.audioEnabled) {
            return bool ? require("@/assets/group/shakeCloseZx2.png") : require("@/assets/group/shakeCloseZx.png");
        }

        if (data.role == 3 && data.online == 3 && data.Ingroup && !data.audioEnabled) {
            return bool ? require("@/assets/group/shakeCloseZx3.png") : require("@/assets/group/shakeCloseZx1.png");
        }
        // 在线不再组
        if (data.role == 0 && data.online == 3 && !data.Ingroup && !data.audioEnabled) {
            return bool ? require("@/assets/group/shakeCloseDdy2.png") : require("@/assets/group/shakeCloseDdy.png");
        }

        if (data.role == 3 && data.online == 3 && !data.Ingroup && !data.audioEnabled) {

            return bool ? require("@/assets/group/shakeCloseDdy3.png") : require("@/assets/group/shakeCloseDdy1.png");
        }
        // 摇闭结束

        if (data.role == 0 && data.online != 3 && data.audioEnabled) {

            return bool ? require("@/assets/group/off-lineUser1.png") : require("@/assets/group/off-lineUser.png");
        }

        if (data.role == 3 && data.online != 3 && data.audioEnabled) {

            return bool ? require("@/assets/group/off-lineDdy1.png") : require("@/assets/group/off-lineDdy.png");
        }

        if (data.role == 0 && data.online == 3 && data.Ingroup && data.audioEnabled) {

            return bool ? require("@/assets/group/xzUser1.png") : require("@/assets/group/xzUser.png");
        }

        if (data.role == 0 && data.online == 3 && !data.Ingroup && data.audioEnabled) {

            return bool ? require("@/assets/group/bzzUser1.png") : require("@/assets/group/bzzUser.png");
        }

        if (data.role == 3 && data.online == 3 && data.Ingroup && data.audioEnabled) {

            return bool ? require("@/assets/group/zzDdy3.png") : require("@/assets/group/zzDdy1.png");
        }

        if (data.role == 3 && data.online == 3 && !data.Ingroup && data.audioEnabled) {

            return bool ? require("@/assets/group/zzDdy2.png") : require("@/assets/group/zzDdy.png");
        }
    }
}

const userServeImg = (data) => {  //用户服务图标
    let img = '';
    if (data.services && data.services.soundRecording) {

        img += `<img class="userimgw" src="${require("@/assets/group/soundrecording.png")}" alt="" />`;
    }
    if (data.services && data.services.sos) {

        img += `<img class="userimgw" src="${require("@/assets/group/sos.png")}" alt="" />`;
    }
    if (data.services && data.services.enclosure) {

        img += `<img class="userimgw" src="${require("@/assets/group/enclosure.png")}" alt="" />`;
    }
    if (data.services && data.services.gps) {

        img += `<img class="userimgw" src="${data.GPSswitch ? require("@/assets/group/gps.png") : require("@/assets/group/gps1.png")}" alt="" />`;
    }
    if (data.services && !data.services.gps) {

        img += `<img class="userimgw" src="${data.celllocation_switch ? require("@/assets/group/jwdd.png") : require("@/assets/group/jwdd1.png")}" alt="" />`;
    }

    return img;
}

export default { upUserImg, userServeImg }